import script from "./SourceItemsCellElementLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./SourceItemsCellElementLite.vue?vue&type=script&setup=true&lang=ts"

import "./SourceItemsCellElementLite.vue?vue&type=style&index=0&id=128224d4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-128224d4"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QSpinner});
